import { SchemaIncidentTiming, type MultiStepFormSchema } from '@/types';
import {
  generateNewClaimStepMedicalExpensesFormSchema,
  type GenerateNewClaimStepMedicalExpensesFormSchemaParams,
} from './stepMedicalExpenses';
import {
  generateNewClaimStepOtherExpensesFormSchema,
  type GenerateNewClaimStepOtherExpensesFormSchemaParams,
} from './stepOtherExpenses';
import {
  generateNewClaimStepWhatHappenedFormSchema,
  type GenerateNewClaimStepWhatHappenedFormSchemaParams,
} from './stepWhatHappened';
import {
  generateNewClaimStepWhereWhenFormSchema,
  type GenerateNewClaimStepWhereWhenFormSchemaParams,
} from './stepWhereWhen';
import {
  generateNewClaimStepWhoFormSchema,
  type GenerateNewClaimStepWhoFormSchemaParams,
} from './stepWho';

type GenerateNewClaimMultiStepFormSchemaParams = GenerateNewClaimStepWhoFormSchemaParams &
  GenerateNewClaimStepWhereWhenFormSchemaParams &
  GenerateNewClaimStepWhatHappenedFormSchemaParams &
  GenerateNewClaimStepMedicalExpensesFormSchemaParams &
  GenerateNewClaimStepOtherExpensesFormSchemaParams;

let multiStepFormSchema: MultiStepFormSchema = [];
function generateNewClaimMultiStepFormSchema({
  listedTravellersOptions,
  policyType,
  incidentTiming,
  medicalExpenseIds,
  additionalExpenseIds,
  cancellationExpenseIds,
}: GenerateNewClaimMultiStepFormSchemaParams = {}): MultiStepFormSchema {
  multiStepFormSchema = [
    generateNewClaimStepWhoFormSchema({
      listedTravellersOptions,
    }),
    generateNewClaimStepWhereWhenFormSchema({
      policyType,
    }),
    generateNewClaimStepWhatHappenedFormSchema({
      incidentTiming,
    }),
  ];

  // Conditional steps to be included if conditions have not been passed.
  if (!incidentTiming || incidentTiming === SchemaIncidentTiming.OnTrip) {
    multiStepFormSchema.push(
      generateNewClaimStepMedicalExpensesFormSchema({
        medicalExpenseIds,
      }),
    );
  }

  multiStepFormSchema.push(
    generateNewClaimStepOtherExpensesFormSchema({
      incidentTiming,
      additionalExpenseIds,
      cancellationExpenseIds,
    }),
  );

  return multiStepFormSchema;
}

function getNewClaimMultiStepFormSchema() {
  if (!multiStepFormSchema.length) {
    // Generate a new schema with all the steps, if its empty!
    multiStepFormSchema = generateNewClaimMultiStepFormSchema();
  }

  return multiStepFormSchema;
}

function getNoOfClaimSchemaSteps() {
  // Number of steps is entirely dependant on generated schema.
  return getNewClaimMultiStepFormSchema().length;
}

export {
  generateNewClaimMultiStepFormSchema,
  getNewClaimMultiStepFormSchema,
  getNoOfClaimSchemaSteps,
};

export type { GenerateNewClaimMultiStepFormSchemaParams };
